import { render, staticRenderFns } from "./BilletsTable.vue?vue&type=template&id=275bb36b"
import script from "./BilletsTable.vue?vue&type=script&lang=js"
export * from "./BilletsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports